var _mask, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCurtainClose2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "hinava_random_uuid_166782800715470345716294259610654271317",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 24,
    height: 24
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 10,
    r: 1.5,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 10,
    r: 1.5,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 9.25,
    width: 20,
    height: 1.5,
    fill: "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 26.0093V9.8H24V25.9905C24 25.9905 23.7823 26.2654 23.6111 26.4046C23.3447 26.6212 23.1714 26.8012 22.8333 26.8C22.4937 26.7987 22.3236 26.6122 22.0556 26.3952C21.886 26.258 21.8814 25.9905 21.6667 25.9905C21.4519 25.9905 21.4473 26.258 21.2778 26.3952C21.0097 26.6122 20.8396 26.8 20.5 26.8C20.1604 26.8 19.9903 26.6122 19.7222 26.3952C19.5527 26.258 19.5481 25.9905 19.3333 25.9905C19.1186 25.9905 19.114 26.258 18.9444 26.3952C18.6764 26.6122 18.5063 26.7987 18.1667 26.8C17.8286 26.8012 17.6578 26.6178 17.3889 26.4046C17.22 26.2708 17 26.0093 17 26.0093Z",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 19.33,
    y1: 14.5,
    x2: 19.33,
    y2: 23.5,
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.67,
    y1: 12.5,
    x2: 21.67,
    y2: 21.5,
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 26.0093V9.8H15V25.9905C15 25.9905 14.7823 26.2654 14.6111 26.4046C14.3447 26.6212 14.1714 26.8012 13.8333 26.8C13.4937 26.7987 13.3236 26.6122 13.0556 26.3952C12.886 26.258 12.8814 25.9905 12.6667 25.9905C12.4519 25.9905 12.4473 26.258 12.2778 26.3952C12.0097 26.6122 11.8396 26.8 11.5 26.8C11.1604 26.8 10.9903 26.6122 10.7222 26.3952C10.5527 26.258 10.5481 25.9905 10.3333 25.9905C10.1186 25.9905 10.114 26.258 9.94444 26.3952C9.67639 26.6122 9.50626 26.7987 9.16667 26.8C8.82864 26.8012 8.65784 26.6178 8.38889 26.4046C8.21998 26.2708 8 26.0093 8 26.0093Z",
    stroke: "#000000"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.67,
    y1: 14.5,
    x2: 12.67,
    y2: 23.5,
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 10.33,
    y1: 12.5,
    x2: 10.33,
    y2: 21.5,
    stroke: "black",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 6C14 4.895 13.105 4 12 4C10.895 4 10 4.895 10 6C10 7.105 10.895 8 12 8C13.105 8 14 7.105 14 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 6C22 4.895 21.105 4 20 4C18.895 4 18 4.895 18 6C18 7.105 18.895 8 20 8C21.105 8 22 7.105 22 6Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#hinava_random_uuid_166782800715470345716294259610654271317)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0H32V32H0V0Z",
    fill: "url(#hinava_random_uuid_290070052989702441687061688776973085760)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "hinava_random_uuid_290070052989702441687061688776973085760",
    x1: 16,
    y1: 10.5107,
    x2: 16,
    y2: 29.0541,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74FFF3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00FFA9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurtainClose2);
export default __webpack_public_path__ + "static/media/curtain-close-2.624e9b3e6863507ceb1b24e030532ab9.svg";
export { ForwardRef as ReactComponent };